module.exports = __webpack_public_path__ + "img/组 2240@2x.3170890f.png";